export default __webpack_public_path__ + "static/media/Ecommerce_Prescript-Assist_Soil_Based_Probiotic_Safer_Medical_of_Montana.c5ea32ea.png";